// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b8c51c9f","952":"32fe70ef"}[chunkId] + ".chunk.js";
};